import './AppHeader.css';

export default function AppHeader({ status = 'READY', sessionId = '0x4F·A7C9' }) {
  return (
    <header className="app-header">
      <div className="app-header__brand">
        <span className="app-header__mark">D!</span>
        <span className="app-header__name">DEBUNKED</span>
        <span className="app-header__version">v0.1 — FORENSIC PHOTO ANALYSIS</span>
      </div>
      <div className="app-header__meta">
        <MetaItem label="SESSION" value={sessionId} />
<MetaItem label="STATUS" value={status} live={status !== 'READY' && status !== 'COMPLETE'} />
      </div>
    </header>
  );
}

function MetaItem({ label, value, live }) {
  return (
    <div className="meta-item">
      <span className="meta-item__label">{label}</span>
      <span className="meta-item__value">
        {live && <span className="meta-item__live-dot">●</span>}
        {value}
      </span>
    </div>
  );
}
